import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const formatTimestamp = (seconds: number) => {
  return new Date(seconds * 1000).toLocaleTimeString([], {
    minute: '2-digit',
    second: '2-digit',
  })
}

export function useQuery() {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}

const _capitalizeFirst = (s: string) => {
  if (!s) return ''
  if (!s.trim().length) return ''
  return s
    .split(' ')
    .map(w => {
      if (w === 'ii') return 'll'
      if (w === 'ii.') return 'll.'
      return w.charAt(0).toUpperCase() + w.slice(1)
    })
    .join(' ')
}

export const capitalizeFirst = _capitalizeFirst
